const interface_container = document.querySelector(".interface_container");
const replay = document.querySelector(".replay");

let interface_transition = false
let interface_reset = false
let interface_count = 0

import interface1 from '/assets/interface/Interface1.png';
import interface2 from '/assets/interface/Interface2.png';
import interface3 from '/assets/interface/Interface3.png';
import interface4 from '/assets/interface/Interface4.png';
import interface5 from '/assets/interface/Interface5.png';
import interface6 from '/assets/interface/Interface6.png';
import interface7 from '/assets/interface/Interface7.png';
import interface8 from '/assets/interface/Interface8.png';
import interface9 from '/assets/interface/Interface9.png';
import interface10 from '/assets/interface/Interface10.png';
import interface11 from '/assets/interface/Interface11.png';
import interface12 from '/assets/interface/Interface12.png';

const interfaces = [interface1, interface2, interface3, interface4,interface5, interface6, interface7, interface8, interface9, interface10, interface11, interface12]

function resetInterface() {
  interface_count = 0
  interface_container.children[0].src = interfaces[0]
  interface_container.children[1].src = interfaces[0]
  interface_container.classList.remove("end")
}



interface_container.addEventListener("click", () => {
  if (interface_transition) { return }
  if (interface_reset) { 
    interface_reset = false
    return }

  interface_count = interface_count + 1

  if (interface_count >= interfaces.length) { 
    interface_container.classList.add("end")
    return }

  interface_container.children[1].style.opacity = '0%'
  interface_container.children[0].src = interfaces[interface_count]
  interface_transition = true
  setTimeout(() => {
    interface_container.children[1].src = interfaces[interface_count]
    interface_container.children[1].style.opacity = '100%'
    interface_transition = false
  }, 300);
  
})


replay.addEventListener("click", () => {
  interface_reset = true
  resetInterface()
})

resetInterface()